import type { AutomationResetState, UITrigger, UIAction, AutomationBox } from './types'

// TODO: some of these functions may not be needed

export function getAutomationAction(actions: any[], id: number | string) {
  let found = null
  let i = actions.length
  while (i--) {
    let k = actions[i].length
    while (k--) {
      if (!actions[i][k].block) {
        continue
      }
      else {
        if (actions[i][k].block.id === id) {
          found = actions[i][k]
          return found
        }
      }
    }
  }

  return found
}

export function getActionBlock(boxes: any, id: number) {
  let found
  let i = boxes.length
  while (i--) {
    let j = boxes[i].length
    while (j--) {
      if (!boxes[i][j].id) {
        continue
      }
      if (boxes[i][j].block.id === id) {
        found = boxes[i][j].block
        return found
      }
    }
  }
  return found
}

export async function getTriggers(data: any, promoterOid: number, automationOid: number): Promise<any> {
  const api = getContext()
  const triggers: any = []
  const arr = Object.entries(data)
  let count = 0

  const addTriggers = new Promise((resolve, _) => {
    arr.forEach(async (val, _, array) => {
      try {
        const item: any = val[1]
        const trigger = defaultTrigger()
        trigger.id = item.oid
        trigger.key = item.type.split('.').slice(1).join('.')
        trigger.config = item.config

        switch (item.type) {
          case 'trigger.purchased.ticket-to-event':
            trigger.name = 'Purchased ticket'
            trigger.icon = 'credit-card'
            if (item.config?.['event-oids']) {
              const select = 'name,description,campaigns,meta,capacity,location,startDate,endDate,timeZone,tourOid,presentation,resources,lastImport,ticket-stats,paymentInfo,provider'
              const resp = await api.$api.event.fetchByOids(promoterOid, item.config['event-oids'], select)

              const events = resp.map((event) => {
                return {
                  name: event.name,
                  location: event.location,
                }
              })
              trigger.meta = {
                events,
              }
            }
            else if (item.config?.['event-oid']) {
              const resp = await api.$api.event.get(promoterOid, item.config['event-oid'])
              trigger.meta = {
                events: [{
                  name: resp.name,
                  location: resp.location,
                }] }
            }
            triggers.push(trigger)

            break
          case 'trigger.purchased.product-from-store':
            trigger.name = 'Purchased product'
            trigger.icon = 'credit-card'

            if (item.config?.['promoter-product-oid']) {
              const resp = await api.$api.automation.getProduct(promoterOid, item.config['promoter-product-oid'])

              trigger.config.frontend = {
                title: resp.title,
                vendor: resp.vendor,
              }
            }

            triggers.push(trigger)

            break
          case 'trigger.campaign.registered':
            trigger.name = 'Registers for campaign'
            trigger.icon = 'target'
            if (item.config?.['campaign-oid']) {
              const resp = await api.$api.campaign.fetchCampaignForAutomation(promoterOid, item.config['campaign-oid'])
              trigger.meta = {
                name: resp.name,
              }
            }
            triggers.push(trigger)

            break
          case 'trigger.messaging.list.subscribed':
            trigger.name = 'Subscribes to list'
            trigger.icon = 'message'
            // the below is to handle the case in which a promoter
            // creates this trigger and references a list, but later
            // deletes that list from their account.
            // We're resetting the config on the backend to an empty
            // object and here on the frontend also.
            if (item.errors?.semantical?.['not-found']) {
              api.$api.automation.updateItemConfig(promoterOid, automationOid, 'trigger', item.oid, {})
              trigger.config = {}
            }
            else if (item.config?.['message-list-oid']) {
              console.log('here')
              const list = await api.$api.messageLists.fetchList(promoterOid, item.config['message-list-oid'])
              trigger.meta.list = list.name
            }
            triggers.push(trigger)

            break

          case 'trigger.messaging.list.unsubscribed':
            trigger.name = 'Unsubscribes from list'
            trigger.icon = 'message'
            // the below is to handle the case in which a promoter
            // creates this trigger and references a list, but later
            // deletes that list from their account.
            // We're resetting the config on the backend to an empty
            // object and here on the frontend also.
            if (item.errors?.semantical?.['not-found']) {
              api.$api.automation.updateItemConfig(promoterOid, automationOid, 'trigger', item.oid, {})
              trigger.config = {}
            }
            else if (item.config?.['message-list-oid']) {
              const list = await api.$api.messageLists.fetchList(promoterOid, item.config['message-list-oid'])
              trigger.meta.list = list.name
            }
            triggers.push(trigger)

            break

          case 'trigger.contact.tag.added':
            trigger.name = 'Tag added'
            trigger.icon = 'contacts'
            if (item.config?.['tag-oid']) {
              const tagResp = await api.$api.tags.fetchTagByOid(promoterOid, item.config['tag-oid'])
              if (tagResp.length) {
                trigger.meta = {
                  name: tagResp[0].name,
                }
              }
            }
            triggers.push(trigger)

            break

          case 'trigger.contact.tag.removed':
            trigger.name = 'Tag removed'
            trigger.icon = 'contacts'
            if (item.config?.['tag-oid']) {
              const tagResp = await api.$api.tags.fetchTagByOid(promoterOid, item.config['tag-oid'])
              if (tagResp.length) {
                trigger.meta = {
                  name: tagResp[0].name,
                }
              }
            }
            triggers.push(trigger)

            break
          case 'trigger.contact.birthday':
            trigger.name = 'Birthday'
            trigger.icon = 'birthday'

            triggers.push(trigger)

            break
          case 'trigger.short-url.visited':
            trigger.name = 'Clicks on short URL'
            trigger.icon = 'other'
            triggers.push(trigger)

            break
          case 'trigger.webhook':
            trigger.name = 'Webhook'
            trigger.icon = 'other'
            triggers.push(trigger)

            break
          case 'trigger.event-date':
            trigger.name = 'Event Date'
            trigger.icon = 'calendar'
            triggers.push(trigger)

            break
          default:
            console.log('An unrecognized trigger type was received:', val)
            break
        }
      }
      catch (error) {
        console.log('Error creating trigger from api response:', error)
      }
      finally {
        count += 1
        if (count === array.length) resolve(true)
      }
    })
  })

  await addTriggers
  return triggers
}

export async function formattedAPIBox(box: any, promoterOid: number, automationOid: number): Promise<any> {
  const api = getContext()
  let actionBox: AutomationBox

  try {
    const block = box.block
    const action = {
      ...defaultAction(),
      id: block.oid,
      key: block.type.split('.').slice(1).join('.'),
      config: block.config,
      parentOutBoxId: block.parentOutBoxId,
    }

    switch (block.type) {
      case 'action.tag.add':
        action.name = 'Add a Tag'
        action.icon = 'contacts'
        if (block.config?.['tag-oid']) {
          const tagResp = await api.$api.tags.fetchTagByOid(promoterOid, block.config['tag-oid'])
          if (tagResp.length) {
            action.meta = {
              name: tagResp[0].name,
            }
          }
        }
        break
      case 'action.tag.remove':
        action.name = 'Remove a Tag'
        action.icon = 'contacts'
        if (block.config?.['tag-oid']) {
          const tagResp = await api.$api.tags.fetchTagByOid(promoterOid, block.config['tag-oid'])
          if (tagResp.length) {
            action.meta = {
              name: tagResp[0].name,
            }
          }
        }
        break
      case 'action.send.sms':
        action.name = 'Send SMS'
        action.icon = 'message'
        break
      case 'action.send.email':
        action.name = 'Send email'
        action.icon = 'message'
        if (block.config?.['promoter-property-oid']) {
          const messageSender = await api.$api.messageSenders.get(promoterOid, block.config['promoter-property-oid'])
          action.meta.messageSender = messageSender
        }
        if (block.config?.['bucket-oid']) {
          const bucket = await api.$api.buckets.fetch(block.config['bucket-oid'])
          action.meta.bucket = bucket
        }
        break
      case 'action.list.add':
        action.name = 'Add to List'
        action.icon = 'message'

        // the below is to handle the case in which a promoter
        // creates this action and references a list, but later
        // deletes that list from their account.
        // We're resetting the config on the backend to an empty
        // object and here on the frontend also.
        if (block.errors?.semantical?.['not-found']) {
          api.automationModule.updateItemConfig(promoterOid, automationOid, 'block', block.oid, {})
          action.config = {}
        }
        else if (block.config?.['message-list']) {
          const list = await api.$api.messageLists.fetchList(promoterOid, block.config['message-list'].oid)
          action.meta.list = list.name
        }
        break
      case 'action.list.remove':
        action.name = 'Remove from List'
        action.icon = 'message'

        // the below is to handle the case in which a promoter
        // creates this action and references a list, but later
        // deletes that list from their account.
        // We're resetting the config on the backend to an empty
        // object and here on the frontend also.
        if (block.errors?.semantical?.['not-found']) {
          api.$api.automationModule.updateItemConfig(promoterOid, automationOid, 'block', block.oid, {})
          action.config = {}
        }
        else if (block.config?.['message-list-oid']) {
          const list = await api.$api.messageLists.fetchList(promoterOid, block.config['message-list-oid'])
          action.meta.list = list.name
        }
        break
      case 'control.if-else':
        action.name = 'If/Else'
        action.icon = 'branch'
        if (block.config?.['filter-group-oid']) {
          if (!block.config?.frontend?.segment) {
            const { filter } = await api.$api.automation.getFilterGroup(promoterOid, block.config['filter-group-oid'])
            action.meta.filter = filter.conditions[0]
          }
        }
        break
      case 'control.delay-by':
        action.name = 'Delay by'
        action.icon = 'clock'
        if (action.config?.['delay-sec']) {
          action.meta = action.config.frontend
        }
        break
      case 'control.wait-until':
        action.name = 'Wait until'
        action.icon = 'calendar'
        break
      case 'control.unique':
        action.name = 'Unique'
        action.icon = 'fingerprint'
        break
      default:
        action.icon = 'message'
        console.error('An unrecognized action type was received from the API: ', block)
    }

    actionBox = {
      ...box,
      block: action,
    }

    return actionBox
  }
  catch (error) {
    console.error('Error creating action from api response:', error)
  }
}

export function defaultAction(): UIAction {
  return {
    id: null,
    key: null,
    name: null,
    type: 'action',
    icon: null,
    parentOutBoxId: null,
    config: {},
    meta: {},
  }
}

export function defaultTrigger(): UITrigger {
  return {
    id: null,
    key: null,
    name: null,
    type: 'trigger',
    icon: null,
    config: {},
    meta: {},
  }
}

export function automationResetState(): AutomationResetState {
  return {
    id: null,
    name: null,
    status: null,
    isUnique: true,
    rootBoxId: null,
    createdAt: null,
    triggers: {
      boxId: null,
      items: [],
    },
    actions: [],
    isEditEnabled: false,
    editableItem: null,
    loading: false,
    newActionIsDragging: false,
    dragOverId: null,
    draggedBox: null,
    selectedSidebarTab: 'triggers',
    zoomVal: 1,
    scrollVals: null,
    isScrolling: null,
    isFullScreen: false,
    actionConfigHasUpdated: null,
    triggerIsMoving: false,
    products: null,
    displayListModal: false,
    isAutomationCreating: false,
  }
}

export const runPromises = async (promiseObject: object) => {
  const keys: any[] = []
  const promises: any[] = []

  Object.entries(promiseObject).forEach(([key, val]) => {
    keys.push(key)
    promises.push(val)
  })

  const data = await Promise.all(promises)
  const merged = data.reduce((obj, value, index) => ({ ...obj, [keys[index]]: value }), {})

  return merged
}
